if (!customElements.get('new-product-media-gallery')) {
  customElements.define(
    'new-product-media-gallery',
    class NewProductMediaGallery extends HTMLElement {
      connectedCallback() {
        this.mainImage = this.querySelector('[data-new-product-media-gallery-main]');
        this.thumbs = Array.from(this.querySelectorAll('[data-new-product-media-gallery-thumb]'));
        this.thumbs.forEach((thumb) => thumb.addEventListener('click', this.onThumbClick.bind(this)));
        this.zoomTrigger = this.querySelector('[data-new-product-media-gallery-zoom-trigger]');

        this.slidesContainer = this.querySelector('[data-new-product-media-gallery-slides]');
        this.slides = Array.from(this.querySelectorAll('[data-new-product-media-gallery-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-new-product-media-gallery-dot]'));
        if (this.slidesContainer && this.slides.length && this.dots.length) {
          this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.onDotClick(index)));
          this.observeSlides();
        }
      }

      onThumbClick(event) {
        const thumb = event.currentTarget;
        if (!this.mainImage || thumb.classList.contains('is-active')) return;

        this.mainImage.removeAttribute('srcset');
        this.mainImage.src = thumb.dataset.fullSrc;
        this.mainImage.alt = thumb.dataset.alt || this.mainImage.alt;

        this.thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));

        // Keep the lightbox trigger pointed at whatever's now showing, so
        // opening it after swapping thumbnails still opens on the right
        // media instead of whatever was originally featured.
        if (this.zoomTrigger && thumb.dataset.mediaId) {
          this.zoomTrigger.dataset.mediaId = thumb.dataset.mediaId;
        }
      }

      onDotClick(index) {
        this.slides[index]?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }

      observeSlides() {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const index = this.slides.indexOf(entry.target);
              this.dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
            });
          },
          { root: this.slidesContainer, threshold: 0.6 }
        );
        this.slides.forEach((slide) => observer.observe(slide));
      }
    }
  );
}
